// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@hardwoods/XDL/types";

import Attention from "@hardwoods/XDL/Icons/Attention";
import CheckCircle from "@hardwoods/XDL/Icons/CheckCircle";
import ErrorCircle from "@hardwoods/XDL/Icons/ErrorCircle";
import Info from "@hardwoods/XDL/Icons/Info";
import { buttonTransparent } from "@hardwoods/XDL/PreStyle/button";
import color from "@hardwoods/XDL/Utilities/color";
import { IconWrapper } from "@insite/mobius/Icon";
import ToastPropsDefault, { toasterProps as toasterPropsDefault } from "@insite/mobius/Toast/presentationProps";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...ToastPropsDefault,
        cssOverrides: {
            toast: css`
                border: 1px solid ${({ messageType }: any) => color(messageType)};
                background: ${({ messageType }: any) => color(`${messageType}.background`)};
            `,
            toastBody: css`
                &&& {
                    margin: 12px;
                }
            `,
        },
        closeButtonProps: {
            color: "transparent",
            buttonType: "solid",
            shape: "rounded",
            css: css`
                ${buttonTransparent}

                position: absolute;
                top: 0;
                right: 0;
                border: 0;
                width: 24px;
                height: 24px;
                padding: 0;
                min-height: 0;
                transition: none;
                &:hover ${IconWrapper} {
                    color: ${color("danger")};
                }
            `,
            size: 12,
        },
        iconProps: {
            size: 18,
        },
        closeButtonIconProps: {
            src: "X",
            size: 14,
            color: "text.secondary",
            css: css`
                &&& {
                    margin-top: 0;
                    transition: none;
                }
            `,
        },
        bodyTypographyProps: {
            size: 13,
            mergeCss: true,
            css: css`
                letter-spacing: 0;
                line-height: 22px;
            `,
        },
        iconSrcByMessage: {
            success: CheckCircle,
            danger: ErrorCircle,
            warning: Attention,
            info: Info,
        },
    },
    toasterProps: toasterPropsDefault,
} as xBaseTheme["toast"];
